import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import { getFontCss } from '@oberoninternal/travelbase-ds/constants/theme';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { logout } from '../../../utils/auth';
import Button from '@oberoninternal/travelbase-ds/components/action/Button';

const LogoutSection = () => {
    const router = useRouter();

    return (
        <div>
            <LogoutItemWrapper>
                <LogoutTitle>
                    <FormattedMessage defaultMessage="Log uit op je Mijn Travelbase account" />
                </LogoutTitle>
            </LogoutItemWrapper>
            <LogoutItemWrapper>
                <LogoutHelpper>
                    <FormattedMessage defaultMessage="Om door te gaan met uitloggen, klik je op de knop ‘Uitloggen’" />
                </LogoutHelpper>
            </LogoutItemWrapper>
            <LogoutItemWrapper>
                <Button
                    onClick={() => {
                        logout();
                        router.push('/logout');
                    }}
                >
                    <FormattedMessage defaultMessage="Uitloggen" />
                </Button>
            </LogoutItemWrapper>
        </div>
    );
};

export default LogoutSection;

const LogoutTitle = styled(Title)`
    ${({ theme }) => getFontCss(theme.fontSizes.title.regular)};
    font-size: 700;
`;

const LogoutHelpper = styled(Body)`
    ${({ theme }) => getFontCss(theme.fontSizes.body.regular)};
`;

const LogoutItemWrapper = styled.div`
    margin-bottom: 2.4rem;
`;
